import React from 'react'
import { Flex, Row, Space, Typography } from 'antd'
import Button from '../../common/Button'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'

const ExpandedRowRender = ({ record, index, memoAction }) => {
  const intl = useIntl()
  return (
    <Flex vertical className="memo-review-expanded">
      <Row className="heading-wrapper full-width">
        <Flex className="heading bold">
          <Typography.Text>{intl.formatMessage({ id: 'memos.dtcDescriptionMemo' })}</Typography.Text>
        </Flex>

        <Flex justify="space-between" className="heading bold">
          <Typography.Text>{intl.formatMessage({ id: 'memos.crowdsourcedMemos' })}</Typography.Text>
          <Space size={'middle'}>
            <Button
              type="link"
              className="link-button"
              onClick={() => {
                memoAction('accept', index)
              }}
            >
              {intl.formatMessage({ id: 'forms.accept' })}
            </Button>

            <Button
              type="link"
              className="link-button"
              onClick={() => {
                memoAction('reject', index)
              }}
            >
              {intl.formatMessage({ id: 'forms.reject' })}
            </Button>
          </Space>
        </Flex>
      </Row>

      <Row className="memo-name-wrapper">
        <Flex align="center" className="memo-name">
          {record?.atMemo?.memo ? (
            <div
              dangerouslySetInnerHTML={{ __html: record?.atMemo?.memo }}
              key={`at-memo`}
            />
          ) : (
            <ExclamationCircleOutlined style={{ fontSize: 18 }} />
          )}
        </Flex>

        <Flex align="center" className="memo-name">
          {record?.memo ? (
            <div
              dangerouslySetInnerHTML={{ __html: record?.memo }}
              key={`tracer-memo`}
            />
          ) : (
            <ExclamationCircleOutlined style={{ fontSize: 18 }} />
          )}
        </Flex>
      </Row>

      <Row className="memo-description-wrapper">
        <Flex className="memo-description">
          {record?.atMemo?.description ? (
            <Typography.Text>{record?.atMemo?.description}</Typography.Text>
          ) : (
            <ExclamationCircleOutlined style={{ fontSize: 18 }} />
          )}
        </Flex>

        <Flex className="memo-description">
          {record.short_desc ? (
            <Typography.Text>{record.short_desc}</Typography.Text>
          ) : (
            <ExclamationCircleOutlined style={{ fontSize: 18 }} />
          )}
        </Flex>
      </Row>
    </Flex>
  )
}

export default ExpandedRowRender
